import React from 'react';
import '../style/ComparisonPage.css';
const ComparisonPage = ({ comparison, onBack}) => {
  if (!comparison) {
    return <h2>No comparison selected</h2>;
  }

  const { car1, car2 } = comparison;

  return (
  <div className="comparison-container">

  <button className="back-btn" onClick={onBack}>
    ← Back to Home
  </button>


  <h1>{car1.name} vs {car2.name}</h1>

  <div className="cars-header">

    <div className="car-card">
      <img src={car1.image} alt={car1.name} />
      <h2>{car1.name}</h2>
      <p>{car1.price}</p>
    </div>

    <div className="vs-badge">VS</div>

    <div className="car-card">
      <img src={car2.image} alt={car2.name} />
      <h2>{car2.name}</h2>
      <p>{car2.price}</p>
    </div>

  </div>

  <div className="specs-card">

    <div className="spec-row">
      <span>Fuel Type</span>
      <span>{car1.fuel}</span>
      <span>{car2.fuel}</span>
    </div>

    <div className="spec-row">
      <span>Mileage</span>
      <span>{car1.mileage}</span>
      <span>{car2.mileage}</span>
    </div>

    <div className="spec-row">
      <span>Engine</span>
      <span>{car1.engine}</span>
      <span>{car2.engine}</span>
    </div>

    <div className="spec-row">
      <span>Transmission</span>
      <span>{car1.transmission}</span>
      <span>{car2.transmission}</span>
    </div>

  </div>

</div>
  );
};

export default ComparisonPage;